import { Directive, ElementRef, OnInit, OnDestroy, inject } from '@angular/core';
import { ScrollPreventService } from './scroll-prevent.service';

@Directive({
  selector: '[appScrollPrevent], .scrollprevent',
  standalone: true
})
export class ScrollPreventDirective implements OnInit, OnDestroy {
  
  private scrollableContainer: HTMLElement;
  private scrollPreventService = inject(ScrollPreventService);
  private el = inject(ElementRef);

  ngOnInit(): void {
    this.scrollableContainer = this.el.nativeElement;
    this.scrollPreventService.applyScrollPrevent(this.scrollableContainer);
  }

  ngOnDestroy(): void {
    this.scrollPreventService.removeScrollPrevent(this.scrollableContainer);
  }
}